<template>
  <div class="container page lottery">
    <van-nav-bar :title="lottery.name" class="nav-bar">
      <template #right>
        <div
          class="right c_k_right"
          @click="showRight"
          v-if="userInfo && userInfo.money !== undefined"
        >
          {{ userInfo.money }}
        </div>
        <img
          :src="lottery.ico"
          v-if="lottery.ico"
          class="c_kk_img"
          @click="toMine"
        />
        <img
          src="/img/neww/userpic.png"
          class="c_kk_img"
          v-else
          @click="toMine"
        />
      </template>
    </van-nav-bar>

    <div class="record">
      <div class="info_c_h">
        <div class="buy-record-link" @click="toBuyRecord">
          購買記錄 <van-icon name="arrow" />
        </div>

        <div class="m1">{{ $t("q25") }}</div>

        <span class="p_number">
          <span>{{ currentExpect }}</span> {{ $t("q26") }}
        </span>

        <div>
          <van-count-down class="c_time" format="mm:ss" :time="time" @finish="check()" />
        </div>
      </div>

      <div class="c_bt_m">
        <div class="left_b">
          <div class="hao">{{ lottery.now_expect }}期</div>
        </div>
      </div>
    </div>

    <div class="history_popup"></div>

    <div class="wrapper" :class="{ 'wrapper--collapsed': bottomCollapsed }">
      <div class="options-bar">
        <div class="put_tit_r">{{ $t("q28") }}</div>
        <div class="game">
          <div class="sumValueTwoSides">
            <div
              class="rectangle large"
              :class="{ active: choose[v.type] }"
              v-for="(v, key) in lottery_peilv_list"
              :key="key"
              @click="choosePlay(v.type, v.name)"
            >
              <div class="c_u_item" :style="{ background: v.color }">
                <img :src="v.img" alt="" />
                <div class="text_k">
                  {{
                    v.name === "big"
                      ? rose
                      : v.name === "small"
                      ? lily
                      : v.name === "one"
                      ? fireworks
                      : balloon
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 收起后，单独显示一条可点开的栏 -->
      <div v-if="bottomCollapsed" class="bottom-expand-trigger" @click="toggleBottomBar">
        <div class="bottom-expand-inner">
          <div class="put_tit_r put_tit_r--mini put_tit_r--trigger">請選擇</div>
          <van-icon name="arrow-up" class="collapse-ico" />
        </div>
      </div>

      <!-- 底部下单 -->
      <div class="bottom-bar" v-show="!bottomCollapsed">
        <div class="wrapper_box active">
          <div class="part_show" @click="toggleBottomBar">
            <div class="put_tit_r put_tit_r--mini">請選擇</div>
            <van-icon name="arrow-down" class="collapse-ico" />
          </div>

          <div class="part_grid">
            <div class="col_left">
              <div class="lbl">積分：</div>
              <div class="lbl">
                總積分：<span class="total_num">{{ totalPoints }}</span>
              </div>
            </div>

            <div class="col_right">
              <div class="amount-wrapper">
                <van-field v-model="money" type="digit" />
              </div>

              <!-- ✅✅ 修复：点击后锁按钮 + 显示提交中，避免“第一次没反应 -> 连点 -> 显示失败” -->
              <div class="buy_btn" :class="{ disabled: orderSubmitting }" @click="jiesuan()">
                {{ orderSubmitting ? "提交中..." : "購買" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 结果列表弹窗结构保留 -->
      <van-popup v-model="active" position="top" :style="{ height: '70%' }">
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
          <div class="wrapper pop_wrapper">
            <div class="item" v-for="(v, key) in lottery_list" :key="key">
              <div class="left">{{ v.expect }}</div>
              <div class="right font-weight">
                <div class="kuaisan-ball left">
                  <span class="ballBox">{{ v.opencode[0] }}</span>
                  <span class="ballBox">{{ v.opencode[1] }}</span>
                  <span class="ballBox" style="margin-right: 20px;">{{ v.opencode[2] }}</span>

                  <span class="res-des ">
                    {{ v.opencode[0] + v.opencode[1] + v.opencode[2] }}
                  </span>

                  <span
                    class="middle"
                    :class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type1')"
                  >
                    {{ isBigSum(v.opencode) ? rose : lily }}
                  </span>

                  <span
                    class="middle"
                    :class="calcBgLs(v.opencode[0], v.opencode[1], v.opencode[2], 'type2')"
                  >
                    {{
                      (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0
                        ? balloon
                        : fireworks
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </van-pull-refresh>
      </van-popup>
    </div>

    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">
        <div
          class="item"
          v-for="(i, index) in gameitemData"
          :key="index"
          @click="tabList(i.id, i.key)"
        >
          <div>{{ $t("q29") }}</div>
          <div style="margin: 15px 0 0 15px;">
            <div
              style="height: 86px;background-color: #fff;width: 60px;display: flex;align-items: center;border-radius: 8px;"
            >
              <van-image width="60" height="61" :src="i.ico" />
            </div>
            <div style="font-size: 14px;">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </van-popup>

    <!-- ✅✅ 自己渲染通知：不依赖 Vant Toast 单例，保证每次都出现 -->
    <transition-group name="order-toast" tag="div" class="order-toast-wrap">
      <div class="order-toast" v-for="t in orderTips" :key="t.id">
        {{ t.text }}
      </div>
    </transition-group>
  </div>
</template>

<script>
var time;
var count = 0;

export default {
  data() {
    return {
      showModel: false,

      rose: "遊艇",
      lily: "跑車",
      fireworks: "火箭",
      balloon: "飛機",

      // ✅✅ 通知
      orderTips: [],
      orderTipSeq: 0,

      // ✅✅ 下单锁
      orderSubmitting: false,

      // ✅✅ 新增：底部购买区收起/展开
      bottomCollapsed: false,

      choose: {
        big: false,
        small: false,
        one: false,
        two: false,
        "3": false,
        "4": false,
        "5": false,
        "6": false,
        "7": false,
        "8": false,
        "9": false,
        "10": false,
        "11": false,
        "12": false,
        "13": false,
        "14": false,
        "15": false,
        "16": false,
        "17": false,
        "18": false,
      },

      playgame: false,
      shopping: false,
      isLoading: false,
      play: {},
      lottery_peilv_list: [],
      lottery_list: {},
      active: false,

      userInfo: {},
      lottery: {},

      shanzi_1: "0",
      shanzi_2: "0",
      shanzi_3: "0",

      sum: 0,
      size: "",
      double: "",
      time: 0,

      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",

      ids: 11,
      keys: 5,
      gameitemData: [],

      userTimer: null,
      userInfoFetching: false,
      userInfoLastAt: 0,
    };
  },

  computed: {
    totalPoints() {
      const m = parseFloat(this.money || 0);
      const n = this.formData.length;
      if (isNaN(m) || n <= 0) return 0;
      return m * n;
    },

    currentExpect() {
      const v =
        this.lottery && this.lottery.now_expect ? String(this.lottery.now_expect) : "";
      if (!v) return "";
      const n = Number(v);
      return Number.isFinite(n) ? String(n + 1) : v;
    },
  },

  mounted() {
    if (this.userTimer) {
      clearInterval(this.userTimer);
      this.userTimer = null;
    }
    this.userTimer = setInterval(() => {
      this.getUserInfo(false);
    }, 10000);
  },

  beforeDestroy() {
    if (this.userTimer) {
      clearInterval(this.userTimer);
      this.userTimer = null;
    }
    if (time) {
      clearInterval(time);
      time = null;
    }

    if (this.orderTips && this.orderTips.length) {
      this.orderTips.forEach((t) => {
        if (t && t.timer) clearTimeout(t.timer);
      });
    }
  },

  methods: {
    // ✅✅ 新增：切换底部购买区
    toggleBottomBar() {
      this.bottomCollapsed = !this.bottomCollapsed;
    },

    // ✅✅ 每次都能显示的通知
    showOrderTip(text) {
      const msg = (text && String(text).trim()) ? String(text).trim() : "提示";
      const id = `${Date.now()}_${++this.orderTipSeq}`;

      if (this.orderTips.length >= 5) {
        const old = this.orderTips.shift();
        if (old && old.timer) clearTimeout(old.timer);
      }

      const item = { id, text: msg, timer: null };
      this.orderTips.push(item);

      item.timer = setTimeout(() => {
        const idx = this.orderTips.findIndex((x) => x.id === id);
        if (idx !== -1) this.orderTips.splice(idx, 1);
      }, 1200);
    },

    // ✅✅ 只有这些才算真失败（硬性拒绝）
    isHardOrderRejectMsg(msg) {
      const s = String(msg || "");
      return /餘額不足|余额不足|密碼|密码|錯誤|错误|封盤|封盘|停盤|停盘|維護|维护|禁止|關閉|关闭|風控|风控|不可下單|不可下单/i.test(s);
    },

    toMine() {
      this.$router.push("/Mine");
    },
    back() {
      return window.history.back();
    },
    toBuyRecord() {
      this.$router.push("/GameRecord");
    },

    sumOpenCode(opencode) {
      if (!opencode || !opencode.length) return 0;
      return (opencode[0] || 0) + (opencode[1] || 0) + (opencode[2] || 0);
    },
    isBigSum(opencode) {
      const s = this.sumOpenCode(opencode);
      return s >= 11 && s <= 18;
    },

    doSub() {
      // ✅✅ 修复：防止连点导致“第一次没反应，第二次显示失败”
      if (this.orderSubmitting) return false;

      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          // ✅✅ 立刻给反馈
          this.orderSubmitting = true;
          this.showOrderTip("提交中...");

          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.currentExpect || this.lottery.now_expect,
            },
            url: "game_place_order",
          })
            .then((res) => {
              // 401 仍然照旧
              if (res && res.code === 401) {
                this.$toast(res.msg);
                return;
              }

              const msg = String(res && res.msg ? res.msg : "");

              // ✅✅ 只有硬性拒绝才提示失败
              if (this.isHardOrderRejectMsg(msg)) {
                this.showOrderTip(msg || "下單失敗");
                return;
              }

              // ✅✅ 核心：不管后端说成功还是失败（但记录已写入的情况），都提示“下单成功”
              this.showOrderTip("下單成功");
              this.allClear();
              this.getUserInfo(true);
            })
            .catch(() => {
              // 网络异常也不误导：让用户去购买记录确认
              this.showOrderTip("網絡異常，請到購買記錄確認");
            })
            .finally(() => {
              this.orderSubmitting = false;
            });

          return true;
        }
      }
    },

    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
    },

    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      return this.doSub();
    },

    choosePlay(type, name) {
      // 收起状态下，点玩法自动展开底部购买区
      if (this.bottomCollapsed) {
        this.bottomCollapsed = false;
      }

      if (this.choose[type] === true) {
        this.choose[type] = false;
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
          }
        }
      } else if (this.choose[type] === false) {
        this.formData.push({ name: name, type: type });
        this.choose[type] = true;
      }

      if (this.formData.length === 1) {
        this.shopping = true;
      }

      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
    },

    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        if (time) {
          clearInterval(time);
          time = null;
        }

        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo(false);
            this.getLotteryInfo();
            this.getLotteryList();

            count++;
            if (count > 5) {
              clearInterval(time);
              time = null;
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },

    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },

    getUserInfo(force = false) {
      if (this.userInfoFetching) return;

      const now = Date.now();
      if (!force && now - this.userInfoLastAt < 1500) return;
      this.userInfoLastAt = now;

      this.userInfoFetching = true;

      this.$http({
        method: "get",
        url: "user_info",
      })
        .then((res) => {
          if (res.code === 200) {
            this.userInfo = res.data;
            if (this.userInfo.is_online != 1) {
              localStorage.clear();
              this.$router.push({ path: "/Login" });
            }
          } else if (res.code === 401) {
            this.$toast(res.msg);
          }
        })
        .catch(() => {})
        .then(() => {
          this.userInfoFetching = false;
        });
    },

    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv",
      }).then((res) => {
        if (res.code === 200) {
          const lottery_peilv_list = res.data || [];

          const iconMap = {
            one:   { img: "/img/neww/huojian.gif", color: "#8948fb" },
            two:   { img: "/img/neww/love.gif",    color: "#ff6398" },
            big:   { img: "/img/neww/youting.gif", color: "#2196f3" },
            small: { img: "/img/neww/meigui.gif",  color: "#ff7d73" },
          };

          const order = ["one", "two", "big", "small"];

          const clist = lottery_peilv_list.map((itemc) => {
            const k = itemc.name || itemc.type;
            const ext = iconMap[k] || {};
            return { ...itemc, ...ext };
          });

          clist.sort((a, b) => {
            const ka = a.name || a.type;
            const kb = b.name || b.type;
            const ia = order.indexOf(ka);
            const ib = order.indexOf(kb);
            return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib);
          });

          this.lottery_peilv_list = clist;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list",
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    getGameItem() {
      this.$http({
        method: "get",
        url: "lottery_list",
      }).then((res) => {
        this.gameitemData = res.data;
      });
    },

    tabList(id, key) {
      this.ids = id;
      this.keys = key;
      this.showModel = false;

      this.getUserInfo(true);
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    },

    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info",
      }).then((res) => {
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }

          this.lottery = res.data;
          this.time = res.data.second * 1000;

          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }

          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];

          this.size = (this.sum % 2 === 1) ? "火箭" : "飛機";
          this.double = (this.sum >= 11 && this.sum <= 18) ? "遊艇" : "跑車";
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },

    calcBgLs(n1, n2, n3, type) {
      let zhi = n1 + n2 + n3;
      if (type === "type1") {
        if (zhi >= 11 && zhi < 18) return "d";
        return "x";
      }
      if (type === "type2") {
        if (zhi % 2 === 0) return "v";
        return "r";
      }
    },
  },

  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo(true);
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

/* ✅✅ 通知样式 */
.order-toast-wrap {
  position: fixed;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  pointer-events: none;
}
.order-toast {
  min-width: 260px;
  max-width: 84vw;
  padding: 12px 18px;
  border-radius: 14px;
  background: rgba(0, 0, 0, 0.78);
  color: #fff;
  font-size: 26px;
  line-height: 1.2;
  text-align: center;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.35);
}
.order-toast-enter-active,
.order-toast-leave-active {
  transition: all 0.18s ease;
}
.order-toast-enter,
.order-toast-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

/* ✅✅ 关键修复：整体布局改成纵向，给中间区域真实可滚动空间 */
.lottery {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #1f1c1f url("/img/neww/room_bg.gif") no-repeat;
  background-size: 94% auto;
  background-position: center 120px;
}

.record {
  flex: 0 0 auto;
  padding-left: 20px;
  padding-right: 20px;
  z-index: 1;
}

.wrapper {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding-bottom: 180px; /* 给底部购买区留空间，防止遮挡 */
  transition: padding-bottom 0.22s ease;
}

/* 收起后给底部“展开条”留空间 */
.wrapper.wrapper--collapsed {
  padding-bottom: 72px;
}

.options-bar {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.options-bar .game {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 30px;
}

/* ✅✅ 下单按钮锁定 */
.buy_btn.disabled {
  opacity: 0.7;
  pointer-events: none;
}

/* —— 你原样式保留（下面不变） —— */
.c_kk_img {
  height: 56px;
  width: 56px;
  border-radius: 50%;
  border: 2px solid #766350;
  margin-left: 20px;
}

.info_c_h {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  color: #fff;
  padding: 60px 30px 10px;

  .m1 {
    padding-bottom: 16px;
  }

  .p_number {
    padding-bottom: 10px;
    font-size: 30px;
    span {
      font-weight: bold;
      font-size: 36px;
    }
  }
}

.buy-record-link {
  position: absolute;
  top: 18px;
  right: 22px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 26px;
  color: #ffffff;
  opacity: 0.95;
  z-index: 3;
  padding: 6px 8px;
  border-radius: 10px;
}
.buy-record-link:active { opacity: 0.75; }
::v-deep .buy-record-link .van-icon {
  font-size: 24px;
  color: #ffffff;
}

.c_bt_m {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 60px 10px 0 30px;

  .left_b {
    display: inline-flex;
    align-items: center;
    color: #fff;

    .hao { font-size: 24px; }

    .bn {
      padding: 0 10px;
      border-radius: 30px;
      margin-left: 10px;
      font-size: 20px;

      &.d { background: #8948fb; }
      &.x { background: #ff6398; }
      &.v { background: #2196f3; }
      &.r { background: #ff7d73; }
    }
  }
}

.nav-bar .right {
  padding-left: 8px;
  padding-right: 8px;
  color: #e6b98a;
  font-size: 36px;
  border-radius: 10px;
  line-height: 60px;
}

.lottery .van-nav-bar {
  background: linear-gradient(to bottom, #1f1c1f 0, #1f1c1f 100%);
}

.van-count-down {
  color: #fff;
  font-size: 28px;
  margin-top: 10px;
  float: right;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 6px;
}

.put_tit_r {
  font-weight: bold;
  color: #e6b98a;
  font-size: 28px;
  padding-left: 16px;
  position: relative;
  margin: 20px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 8px;
    height: 30px;
    background: linear-gradient(to right, #ff7a8d 0%, #ff4d67 100%);
    left: 0;
    top: 6px;
  }
}

.sumValueTwoSides {
  display: flex;
  padding: 10px 0 20px;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  .c_u_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 40px 20px 10px;
    border: 4px solid transparent;

    img { width: 130px; }
  }
}

.rectangle { overflow: hidden; }

.rectangle.large {
  width: calc(50% - 4vw) !important;
  text-align: center;
  background: #fff;
  box-shadow: 0 4px 24px 0 rgba(0, 0, 0, .1);
  margin: 0 0 4vw 20px;
  width: 20%;
  border-radius: 20px;
  color: #fff;

  &.active {
    position: relative;

    &::after {
      content: "";
      background: url(/img/neww/ico_yes.png) 100% 100% no-repeat;
      background-size: 50px auto;
      width: 60px;
      height: 60px;
      position: absolute;
      bottom: 2px;
      right: 2px;
      display: block;
    }

    .c_u_item {
      background-color: #212121 !important;
      color: #f3c7a2 !important;
      box-sizing: border-box;
      border: 4px solid #766350;
    }
  }
}

.bottom-bar {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0px;
  height: 160px;
  z-index: 2;
}

.wrapper_box {
  background: linear-gradient(120deg, #212121, #313131);
  transform: translateY(100%);
  padding: 10px 14px 14px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;

  &.active { transform: translateY(-100%); }

  .put_tit_r--mini { margin: 10px 0 0 0; }

  .part_show {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 6px 6px;
    cursor: pointer;
    user-select: none;
  }

  .collapse-ico {
    font-size: 26px;
    color: #766350;
  }

  .part_grid {
    display: flex;
    align-items: stretch;
    padding: 6px 6px 0;
    gap: 12px;
  }

  .col_left {
    flex: 0 0 38%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 6px 0;
  }

  .lbl {
    position: relative;
    padding-left: 16px;
    color: #c5c5c5;
    font-size: 28px;
    line-height: 44px;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 8px;
      width: 6px;
      height: 28px;
      border-radius: 3px;
      background: linear-gradient(to bottom, #ff7a8d 0%, #ff4d67 100%);
    }
  }

  .total_num {
    margin-left: 8px;
    color: #ff4d67;
    font-weight: 700;
    font-size: 30px;
  }

  .col_right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 6px 0 0;
  }

  .amount-wrapper { width: 100%; }

  ::v-deep .van-cell {
    margin: 0;
    border: 1px solid #766350;
    background: linear-gradient(120deg, #212121, #313131);
    border-radius: 10px;
    padding: 8px 14px;
  }

  ::v-deep .van-field__control {
    color: #e6b98a;
    font-size: 28px;
  }

  .buy_btn {
    margin-top: 12px;
    width: 100%;
    text-align: center;
    padding: 14px 0;
    border-radius: 10px;
    background: linear-gradient(180deg, #efcba7, #dcab76);
    color: #333;
    font-weight: 700;
    font-size: 28px;
  }
}

/* 收起后显示的单独触发条 */
.bottom-expand-trigger {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
}

.bottom-expand-inner {
  background: linear-gradient(120deg, #212121, #313131);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 8px 14px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.put_tit_r--trigger {
  margin: 0 !important;
}

.bottom-expand-inner .collapse-ico {
  font-size: 26px;
  color: #766350;
}
</style>